import { WFComponent } from "@xatom/core";
import { gaEventTrigger } from "../../utils";
import axios from "axios";
import { API_ENDPOINT } from "../../config";

export const productPage = async () => {
    const compareButton = new WFComponent(`[xa-type='compare-btn']`);
    const insideTheBoxVideo = new WFComponent(`[xa-type="inside-the-box-video"]`);
    const buySampleNowButton = new WFComponent(`[xa-type="buy-sample-now"]`);
    const nutritionFactsSection = new WFComponent(`[xa-type="nutritional-facts-section"]`);
    compareButton.on("click", async () => {
        gaEventTrigger(window?.location?.pathname?.split("/")[2]?.replace(/-/g, " "), "Compare Button Clicked");
    });
    insideTheBoxVideo.on("click", async () => {
        gaEventTrigger(window?.location?.pathname?.split("/")[2]?.replace(/-/g, " "), "Inside The Box Video Clicked");
    });
    buySampleNowButton.on("click", async () => {
        gaEventTrigger(window?.location?.pathname?.split("/")[2]?.replace(/-/g, " "), "Buy Sample Now Button Clicked");
    });
    nutritionFactsSection.on("click", async () => {
        gaEventTrigger(window?.location?.pathname?.split("/")[2]?.replace(/-/g, " "), "Nutrition Facts Section Clicked");
    });
    const token = localStorage.getItem("_ms-mid");
    const categorySlug = new WFComponent(`[xa-type='product-category-slug']`).getText();
    const result = (await axios.get(`${API_ENDPOINT}/airtable/category/fields?categorySlug=${categorySlug}`, { headers: { authorization: `Bearer ${token}` } })).data.data;
    if (result?.fields?.["Texture Fields"]?.length > 0) {
        const textureFields = result?.fields?.["Texture Fields"].split(",").map((item: string) => item.trim());
        textureFields.forEach((item: string, index: number) => {
            const textureField = new WFComponent(`[xa-type='texture-${index+1}']`);
            textureField.setText(item);
        });
    } else {
        console.log("No fields found!");
    }
}